// extracted by mini-css-extract-plugin
module.exports = {"defaultColor":"Status_defaultColor__38p9P","green":"Status_green__1M3TV","amber":"Status_amber__2de56"};